"use client";

import { useState, useEffect, ComponentPropsWithoutRef } from "react";
import { Header as GlobalHeader } from "../layout/header";
import { PortalNav } from "./nav";
import { PortalHeaderSearch } from "./header-search";
import { PortalHeaderFeedback } from "./header-feedback";
import { PortalHeaderUserMenu } from "./header-user-menu";
import {
  fetchObservatories,
  type Observatory,
} from "../../services/observatories";
import { fetchTags, type Tag } from "../../services/tags";
import { cn } from "../../lib/utils";
import { useTranslations } from "use-intl";

interface PortalHeaderProps extends ComponentPropsWithoutRef<"header"> {}

function PortalHeader({ className }: Readonly<PortalHeaderProps>) {
  const t = useTranslations("global.Branding");
  const [observatories, setObservatories] = useState<Observatory[]>([]);
  const [tags, setTags] = useState<Tag[]>([]);

  const url = "https://data.oreme.org/";

  useEffect(() => {
    fetchObservatories()
      .then((observatories) => observatories.filter((o) => o.portalURL))
      .then(setObservatories)
      .catch(console.error);
    fetchTags()
      .then((tags) => tags.filter((t) => t.isGlossary))
      .then(setTags)
      .catch(console.error);
  }, []);

  return (
    <GlobalHeader
      title={t("title")}
      href={url}
      className={cn("font-inter", className)}
    >
      <div className="fixed inset-x-0">
        <PortalNav />
      </div>
      <ul className="relative z-10 flex flex-row list-none gap-2 items-center h-8">
        {observatories.length && tags.length ? (
          <li>
            <PortalHeaderSearch observatories={observatories} tags={tags} />
          </li>
        ) : null}
        <li>
          <PortalHeaderFeedback />
        </li>
        <li>
          <PortalHeaderUserMenu />
        </li>
        <li className="md:hidden">
          <PortalNav isMobile />
        </li>
      </ul>
    </GlobalHeader>
  );
}

export { PortalHeader };
